import axios from 'axios';
import config from './config';
import getCookie from './Cookies';

export const getForgotPasswordURL = async (partnerId) => {
  const cookie = getCookie();

  const body = {
    partnerId: partnerId,
    secureCookie: cookie,
    callerReferenceNo: new Date().getTime().toString()
  };


  const response = await axios.post(`${config.MyAccountURL}api/partner/getForgotPasswordURL`, body, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });

  console.log('getForgotPasswordURL', response.data);
  return response.data;
};